<template>
  <div class="container">
    <div class="titleVa">
      <div class="textLeft">
        <p>BCA Virtual Account</p>
      </div>
      <div>
        <v-img
          max-height="40"
          max-width="40"
          src="@/assets/bca_logo_1.svg"
          class="textRight"
        ></v-img>
      </div>
      <div class="textLeft mt-3">
        <p>Harga Total</p>
      </div>
      <div>
        <p class="textRight mt-3" style="color: crimson;">
          {{ this.hargaTotal }}
        </p>
      </div>
    </div>
    <div class="detailVa">
      <div>
        <p>Nomor Virtual Account</p>
        <div class="noVa" id="myVa">
          {{ this.va }}
        </div>
      </div>
      <div style="padding-top: 20px">
        <p class="textRight copyText" @click="copyText">
          Salin
        </p>
        <span>
          <v-img
            max-height="20"
            max-width="20"
            src="@/assets/receipt_long.png"
            class="textRight"
          ></v-img>
        </span>
      </div>
    </div>
    <div class="action">
      <button class="back" @click="$router.back()">
        <span>Kembali</span>
      </button>
      <button class="shoping" @click="toDashboard">
        <span>Belanja Lagi</span>
      </button>
    </div>
    <div>
      <p>Cara Pembayaran</p>
    </div>
    <v-expansion-panels accordion>
      <v-expansion-panel v-for="tutor in textTutorials" :key="tutor.id">
        <v-expansion-panel-header>{{ tutor.title }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <ol>
            <li v-for="detail in tutor.text" :key="detail.dtl">
              {{ detail.dtl }}
            </li>
          </ol>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div>
      
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      va: "",
      hargaTotal: "",
      minimumPricePayment: 0,
    };
  },
  methods: {
    ...mapActions(["getProfile", "checkoutOrder", "getVA","getProfile"]),
    toDashboard() {
      this.successAddToCart = false;
      this.$router.push(`/dashboard`);
    },
    copyText() {
      navigator.clipboard.writeText(this.va);

      alert("Nomor Virtual Account berhasil di salin");
    },
    toTransaction() {
      this.$router.push(`/transactions`);
    },
    getTotalHarga() {
      this.checkoutOrder().then((response) => {
        this.minimumPricePayment = response.data.minimumPriceOrder;
        this.hargaTotal = response.data.totalPriceOrder;
      });
    },
  },
  mounted() {
    this.getTotalHarga();

    this.getVA().then((resp) => {
      this.va = resp.data.data.distributorVA;
    });
    this.getProfile().then((resp) => {
        console.log(resp)
        this.va = this.va + resp.data.data.oid;
      });
  },
  computed: {
    ...mapState([
      'totalToBePaid','profile'
    ]),
    textTutorials(){
      return [
        {
          id: 1,
          title: "ATM BCA",
          text: [
            {
              dtl:
                "Pastikan nominal Total Tagihan kamu tepat atau melebihi " +
                "Rp. "+this.humanFormat(this.minimumPricePayment),
            },
            { dtl: "Masukkan Kartu ATM BCA & PIN" },
            {
              dtl:
                "Pilih menu Transaksi Lainnya > Transfer > ke Rekening BCA Virtual Account",
            },
            { dtl: "Masukkan Nomor VA kamu" },
            {
              dtl:
                "Di halaman konfirmasi, pastikan detil pembayaran sudah sesuai seperti No VA, Nama, Perus/Produk dan Total Tagihan",
            },
            { dtl: "Masukkan Jumlah Transfer sesuai" },
            { dtl: "Ikuti instruksi untuk menyelesaikan transaksi" },
            { dtl: "Simpan struk transaksi sebagai bukti pembayaran" },
          ],
        },
        {
          id: 2,
          title: "my-BCA (Mobile)",
          text: [
            {
              dtl:
                "Pastikan nominal Total Tagihan kamu tepat atau melebihi " +
                "Rp. "+this.humanFormat(this.minimumPricePayment),
            },
            { dtl: "Lakukan log in pada aplikasi BCA Mobile" },
            { dtl: "Pilih menu m-BCA, kemudian masukkan kode akses m-BCA" },
            { dtl: "Pilih m-Transfer > BCA Virtual Account" },
            { dtl: "Pilih dari Daftar Transfer, atau masukkan nomor VA kamu" },
            { dtl: "Masukkan pin m-BCA" },
            {
              dtl:
                "Pembayaran selesai. Simpan notifikasi yang muncul sebagai bukti pembayaran",
            },
          ],
        },
        {
          id: 3,
          title: "Kantor Bank BCA",
          text: [
            {
              dtl:
                "Pastikan nominal Total Tagihan kamu tepat atau melebihi " +
                "Rp. "+this.humanFormat(this.minimumPricePayment),
            },
            {
              dtl: "Ambil nomor antrian transaksi Teller dan isi slip setoran",
            },
            { dtl: "Serahkan slip dan jumlah setoran kepada Teller BCA" },
            { dtl: "Teller BCA akan melakukan validasi transaksi" },
            {
              dtl:
                "Simpan slip setoran hasil validasi sebagai bukti pembayaran",
            },
          ],
        },
      
      ]
    }
  }
};
</script>

<style scoped src="./Payment.scss" lang="scss" />
